import userRoutes from '@/router/routes/user';
import orderRoutes from '@/router/routes/order';
import styleGuideRoutes from '@/router/routes/styleguide';
import callbackRoutes from '@/router/unAuthRoutes/callback';

let children = [
  ...userRoutes,
  ...orderRoutes,
  ...callbackRoutes,
];

if (process.env.NODE_ENV === 'development') {
  // Add the style guide route if the process is running in development mode
  children = children.concat(styleGuideRoutes);
}

let routes = [
  {
    path: '/',
    component: () => import('@/components/common/RooshRouterView'),
    redirect: {
      name: 'order.index'
    },
    children: [
      ...children,
    ],
  }
];

export default routes;
